import request from '../../../shared/request'

export function getJobSiteRFIs(job_id) {
  return request(`/job/job_site_rfis/${job_id}/`)
}

export function getRFIData(rfi_id) {
  return request(`/job/job_site_rfis/${rfi_id}/info`)
}

export function createJobSiteRFI(payload) {
  return request(`/job/job_site_rfis/${payload.rfi_data.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobSiteRFI(payload) {
  return request(`/job/job_site_rfis/${payload.rfi_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSiteRFI(rfi_id) {
  return request(`/job/job_site_rfis/${rfi_id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/job_site_rfis/${payload.rfiId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(rfiId) {
  return request(`/job/job_site_rfis/${rfiId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_site_rfis/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_site_rfis/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteRfis.js